import React from 'react'

const PageContentWrapper = ({children}) => {
    return (
        <div className="grid">
            <div className="col-12">
                <div className="card">{children}</div>
            </div>
        </div>
    )
}

export default PageContentWrapper
